import React from 'react';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default function AvatarMenu({ user, onAccount = () => {}, onLogout = () => {} }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const initial = (user?.email || user?.name || '?').trim().charAt(0).toUpperCase() || '?';

  return (
    <>
      <Tooltip title={user?.email || 'Account'}>
        <IconButton onClick={handleOpen} size="small" sx={{ ml: 1 }}>
          <Avatar sx={{ width: 34, height: 34, bgcolor: '#F3B266', color: '#2c2017', fontWeight: 700 }}>
            {initial}
          </Avatar>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            onAccount && onAccount();
          }}
        >
          My Account
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            onLogout && onLogout();
          }}
        >
          Sign out
        </MenuItem>
      </Menu>
    </>
  );
}